<template>
  <div class="cpt-feedback-channel">
    <div class="self-stretch text-tx-1 text-[14px] font-bold leading-[normal] my-[20px]">反馈频道</div>
    <div class="room-team-tools-wrapper">
      <div class="pointer-wrapper between not-cursor !h-[50px]">
        <p>关联频道</p>
        <ChannelSelector 
          class="team-tools-input prefix unset-color"
          :value="feedback_channel" 
          :channels="textChannelList"
          @change="handleChangeChannel"
          :need_request="false"
        />
      </div>
    </div>
    <div class="py-[4px] pl-[12px] pr-[4px] bg-fl-2 rounded-[5px]">
      <div class="h-[42px] text-tx-2 text-[14px] leading-[42px]">添加反馈问题类别</div>
      <div class="flex-items-center flex-wrap">
        <div
          class="flex-items-center w-[212px] h-[32px] pr-[4px] bg-op-s2 rounded-[5px] mr-[8px] mb-[8px]"
          v-if="show_add_input"
        >
          <Input
            ref="add-input"
            v-model="add_feedback_type"
            class="!h-[32px] bg-transparent"
            :maxLength="30"
            @keyup.enter.stop="confirmAddFeedbackCategory"
          />
          <div
            class="flex-center w-[46px] h-[24px] bg-op-1 rounded-[3px] pointer text-op-5 text-[12px] leading-[16px] flex-shrink-0"
            @click="confirmAddFeedbackCategory"
          >
            确定
          </div>
        </div>
        <div v-else class="feedback-category-item add-item" @click="handleAddFeedbackCategory">
          <i class="iconfont icon-add-bold"></i>
          <span>添加类别</span>
        </div>
        <div
          class="feedback-category-item"
          :class="{'disable-delete': item === '其他'}"
          v-for="item in feedback_types"
          :key="item"
          @click="handleDeleteFeedbackCategory(item)"
        >
          <span>{{ item }}</span>
          <i class="iconfont icon-close-bold" v-if="item !== '其他'"></i>
        </div>
      </div>
    </div>
    <div class="module-divider"></div>
  </div>
</template>

<script>
import { upsertRoomFeedback, getRoomFeedbackTypes, deleteRoomFeedback, editRoomDefaultSetting } from '_api/room'
import ChannelSelector from '_com/busy/channelSelector';
import { CHANNEL_TYPES } from '_lib/constants/channel';
export default {
  components: {
    ChannelSelector
  },
  props: {
    textChannelList: {
      type: Array,
      default: () => [],
    },
    roomInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      feedback_channel: '0',
      feedback_types: [],
      roomThemeKey: 0,
      show_add_input: false,
      add_feedback_type: '',
      CHANNEL_TYPES
    }
  },
  created() {
    getRoomFeedbackTypes({
      room_id: this.roomInfo.room_id
    }).then(({ data }) => {
      this.feedback_types = data.result.list || []
    })
  },
  mounted() {
    this.feedback_channel = this.roomInfo.room_setting.feedback_channel || '0'
    const channel = this.textChannelList.find(item => item.channel_id == this.feedback_channel)
    if (!channel) {
      this.feedback_channel = '0'
    }
    this.key_timer = setTimeout(() => {
      this.roomThemeKey = Date.now();
    }, 500);
  },
  beforeDestroy() {
    clearTimeout(this.key_timer)
  },
  computed: {
    feedbackSettingChannel () {
      return this.textChannelList.find(item => item.channel_id == this.feedback_channel) || {}
    },
  },
  methods: {
    handleAddFeedbackCategory() {
      if (this.upsert_lock) return
      this.show_add_input = true;
      this.add_feedback_type = ''
      this.$nextTick(() => {
        this.$refs['add-input'].focus();
      });
    },
    confirmAddFeedbackCategory() {
      if (this.upsert_lock) return
      const category = this.add_feedback_type.trim();
      if (!category || this.feedback_types.includes(category)) {
        this.add_feedback_type = '';
        this.show_add_input = false;
        return;
      }
      this.feedback_types.push(category);
      this.show_add_input = false;
      this.add_feedback_type = '';
      this.upsert_lock = true
      upsertRoomFeedback({}, {
        room_id: this.roomInfo.room_id,
        feedbacks: this.feedback_types
      }).then(({ data }) => {
        if (data.status === 'ok') {
        }
      }).finally(() => {
        this.upsert_lock = false
      })
    },
    handleDeleteFeedbackCategory (item) {
      if (item === '其他') {
        return
      }
      deleteRoomFeedback({}, {
        room_id: this.roomInfo.room_id,
        feedback: item
      }).then(({ data }) => {
        if (data.status === 'ok') {
          const index = this.feedback_types.indexOf(item)
          if (index !== -1) {
            this.feedback_types.splice(index, 1);
          }
        }
      })
    },
    handleChangeChannel(val) {
      if (this.lock) return
      this.lock = true
      editRoomDefaultSetting({}, {
        setting: 'feedback_channel',
        room_id: this.roomInfo.room_id,
        value: val
      }).finally(() => {
        this.feedback_channel = val
        this.lock = false
      })
    }
  }
}
</script>

<style lang="scss">
.cpt-feedback-channel {
  .feedback-category-item {
    display: flex;
    align-items: center;
    margin-right: 8px;
    margin-bottom: 8px;
    height: 30px;
    padding: 0 10px;
    border-radius: 4px;
    cursor: pointer;
    background: $d-op-1;
    color: $d-op-5;
    &.disable-delete {
      cursor: default;
    }
    &.add-item {
      background: $d-bd-fl;
      color: $ct-wh-5;
      .iconfont {
        color: $ct-wh-5;
        margin-right: 3px;
        margin-left: 0;
      }
    }
    .iconfont {
      font-size: 12px;
      color: $d-tx-3;
      margin-left: 3px;
    }
    span {
      font-size: 12px;
      line-height: 16px;
      
    }
  }
}
</style>